import { useMutation } from '@tanstack/react-query';
import { putCallsToAgentRatio } from '../../api/putCallsToAgentRatio';
import { queryClient } from 'services/providers/QueryProvider';

export const useUpdateCallsToAgentRatio = () => {
    const { mutate: updateCallsToAgentRatio, ...rest } = useMutation({
        mutationFn: ({ id, ratio }: { id: string; ratio: number }) => putCallsToAgentRatio(id, ratio),
        onSuccess: () => {
            queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey.includes('agenticWorkflowDetails'),
            });
        },
    });

    return {
        updateCallsToAgentRatio,
        ...rest,
    };
};
